





















import { Component, Vue, Watch } from "vue-property-decorator";
import { AppConstants, Models, apiService, Interfaces } from "@/core/Export";
import store from "@/store";
@Component({
  components: {}
})
export default class RedRouteBeforeContinuePage extends Vue {
  requestNo: number = 0;
  year: number = 0;
  constructor() {
    super();
  }

  created() {
    let params = this.$route.params;
    this.requestNo = Number(params.requestNo);
    this.year = Number(params.year);
  }

  onContinueRequestForResident() {
    this.appEnv.canViewRequestRouteRedPage = true;
    this.$router.push({
      name: AppConstants.Routes.RedRoute,
      params: { requestNo: this.requestNo.toString() }
    });
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
